module.exports = __webpack_public_path__ + "img/2015-2.849ae1cd.jpg";